(function() {
    'use strict';
    angular
        .module('atheer')
        .component('tabsWidget', {
            templateUrl: 'core/components/tabs/tabs-widget.tmpl.html',
            controller: TabsWidget,
            controllerAs: 'vm',
            bindings: {
                languages: '<',
                countries: '<'
            }
        });

    /* @ngInject */
    function TabsWidget(paginationConstants) {
        var vm = this;

        vm.tableQueries = {
            languages: {
                order: '-percent',
                limit: paginationConstants.itemsPerPage,
                page: 1
            },
            countries: {
                order: '-percent',
                limit: paginationConstants.itemsPerPage,
                page: 1
            }
        };
    }
})();
